/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BanOrUnbanUserFromAllCommunitiesBody
 */
export interface BanOrUnbanUserFromAllCommunitiesBody {
    /**
     * 
     * @type {string}
     * @memberof BanOrUnbanUserFromAllCommunitiesBody
     */
    userId: string;
    /**
     * 
     * @type {boolean}
     * @memberof BanOrUnbanUserFromAllCommunitiesBody
     */
    ban: boolean;
}

/**
 * Check if a given object implements the BanOrUnbanUserFromAllCommunitiesBody interface.
 */
export function instanceOfBanOrUnbanUserFromAllCommunitiesBody(value: object): value is BanOrUnbanUserFromAllCommunitiesBody {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('ban' in value) || value['ban'] === undefined) return false;
    return true;
}

export function BanOrUnbanUserFromAllCommunitiesBodyFromJSON(json: any): BanOrUnbanUserFromAllCommunitiesBody {
    return BanOrUnbanUserFromAllCommunitiesBodyFromJSONTyped(json, false);
}

export function BanOrUnbanUserFromAllCommunitiesBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BanOrUnbanUserFromAllCommunitiesBody {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'ban': json['ban'],
    };
}

export function BanOrUnbanUserFromAllCommunitiesBodyToJSON(json: any): BanOrUnbanUserFromAllCommunitiesBody {
    return BanOrUnbanUserFromAllCommunitiesBodyToJSONTyped(json, false);
}

export function BanOrUnbanUserFromAllCommunitiesBodyToJSONTyped(value?: BanOrUnbanUserFromAllCommunitiesBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'ban': value['ban'],
    };
}

